import React from 'react';
import { resizeLegalIframe } from '../../utils/legalIframeResize';

export default function Privacy(props) {
  return (
    <>
      <section className="location_box">
        <ul className="location_001">
          <li>홈</li>
          <li>개인정보취급방침</li>
        </ul>
      </section>

      <main>
        <section className="contants_box contants_box_02">
          <h2 className="tit_01">개인정보취급방침</h2>

          <article className="contants_box_02 agreement_box">
            <iframe
              src="/privacy_wrap.html"
              title="privacy_wrap"
              onLoad={resizeLegalIframe}
            ></iframe>
          </article>
        </section>
      </main>
    </>
  );
}
